const $ = jQuery.noConflict();

const lightbox = document.createElement('div');
const lightboxInner = document.createElement('div');

const openLightbox = (e) => {
	e.preventDefault();
	lightboxInner.innerHTML = '';
	let slideNumber = 0;
	const parentSelector = e.currentTarget.getAttribute('data-parent');
	let allButtons;

	document.body.classList.add('lock-scroll');

	if (lightboxInner.classList.contains('slick-slider')) {
		$('.dynamic-lightbox__inner').slick('unslick');
	}

	if (parentSelector) {
		allButtons = e.currentTarget
			.closest('.' + parentSelector)
			.querySelectorAll('.lightbox-button');
	} else {
		allButtons =
			e.currentTarget.parentElement.querySelectorAll('.lightbox-button');
	}

	if (allButtons.length > 0) {
		allButtons.forEach((button, index) => {
			const src = button.getAttribute('data-src');
			const width = button.getAttribute('data-width');
			const height = button.getAttribute('data-height');
			const srcset = button.getAttribute('data-srcset');
			const alt = button.getAttribute('data-alt');
			const caption = button.getAttribute('data-caption');

			const lightboxSlide = document.createElement('div');
			const lightboxImage = document.createElement('img');

			lightboxSlide.classList.add('dynamic-lightbox__slide');

			if (button === e.currentTarget) {
				slideNumber = index;
			}

			if (src) {
				lightboxImage.setAttribute('src', src);
			}

			if (width) {
				lightboxImage.setAttribute('width', width);
			}

			if (height) {
				lightboxImage.setAttribute('height', height);
			}

			if (srcset) {
				lightboxImage.setAttribute('srcset', srcset);
			}

			if (alt) {
				lightboxImage.setAttribute('alt', alt);
			}

			lightboxSlide.appendChild(lightboxImage);

			if (caption) {
				const captionElement = document.createElement('div');
				const captionElementText = document.createTextNode(caption);

				captionElement.classList.add('dynamic-lightbox__caption');
				captionElement.appendChild(captionElementText);

				lightboxSlide.appendChild(captionElement);
			}

			lightboxInner.appendChild(lightboxSlide);
		});

		if (allButtons.length > 1) {
			const lightboxSlider = $('.dynamic-lightbox__inner').slick({
				prevArrow:
					'<button type="button" class="slick-prev slick-arrow--color-alt">Previous</button>',
				nextArrow:
					'<button type="button" class="slick-next slick-arrow--color-alt">Next</button>',
			});

			lightboxSlider.slick('slickGoTo', slideNumber, true);
		}
	}

	lightbox.classList.add('active');

	document.addEventListener('keydown', closeLightbox);

	setTimeout(function () {
		lightbox.classList.add('visible');
	}, 1);
};

const closeLightbox = (e) => {
	document.body.classList.remove('lock-scroll');
	if (e.key === undefined || e.key === 'Escape') {
		e.preventDefault();

		lightbox.classList.remove('visible');

		setTimeout(function () {
			lightbox.classList.remove('active');
		}, 400);

		document.removeEventListener('keydown', closeLightbox);
	}
};

const init = () => {
	const lightboxButtons = document.querySelectorAll('.lightbox-button');

	if (lightboxButtons.length) {
		const lightboxCloseButton = document.createElement('button');

		lightbox.classList.add('dynamic-lightbox');
		lightboxInner.classList.add('dynamic-lightbox__inner');
		lightboxCloseButton.classList.add('dynamic-lightbox__close-button');
		lightboxCloseButton.setAttribute('aria-label', 'Close Lightbox');

		lightbox.appendChild(lightboxInner);
		lightbox.appendChild(lightboxCloseButton);

		document.body.appendChild(lightbox);

		lightboxButtons.forEach((lightboxButton) => {
			lightboxButton.addEventListener('click', openLightbox);
		});

		lightboxCloseButton.addEventListener('click', closeLightbox);
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		init();

		document.addEventListener('eight29-filters-rendered', init);
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
